import { getStore } from "./store.svelte.js";

const baseURL = import.meta.env.VITE_BASE_URL;

const store = getStore();

const HOTSPOT_NODE_HTML = {
  identity: "node-0401",
  "logged-in": "no",
  username: "",
  mac: "62:B7:9B:07:74:BA",
};

if (import.meta.env.MODE === "production") {
  console.log("We are in production mode");
} else if (import.meta.env.MODE === "development") {
  console.log("We are in development mode");
}

let env = { MODE: import.meta.env.MODE }; // Replace with your actual env variable if necessary

export async function loadingStart() {
  // Wait 120ms before displaying loading indicator, makes apps feel faster
  await new Promise((r) => setTimeout(r, 120));
  store.loadingIndicator = true;
}

export function loadingStop() {
  store.loadingIndicator = false;
}

export async function getHotspotData() {
  const store = getStore();
  console.log("Utils:Store:getHotspotData", store);
  console.log("getHotspotData");
  console.log("env.MODE", env.MODE);

  if (env.MODE === "development") {
    store.isConnectedToHotspot = true;
    store.macAddress = HOTSPOT_NODE_HTML.mac;
    if (HOTSPOT_NODE_HTML.mac === "") {
      store.loading = false;
    }
    console.log("store.macAddress", store.macAddress);
  } else {
    try {
      const response = await fetch(
        "https://hotspot.toomuchwifi.co.za/node.html",
        {
          method: "GET",
          credentials: "omit", // Equivalent to withCredentials: false
        },
      );

      const data = await response.json();

      store.isConnectedToHotspot = true;
      const loggedInStatus = data["logged-in"];
      store.isAuthenticatedOnHotspot = loggedInStatus === "yes";

      if ("mac" in data) {
        store.macAddress = data["mac"];
      } else {
        store.loading = false;
      }

      store.loading = false;
    } catch (error) {
      console.error(error);
      store.isConnectedToHotspot = false;
      store.macAddress = null;
      store.loading = false;
    }
  }
}

export async function getActiveAllocation(cellphone) {
  try {
    let response = await fetch(`${baseURL}allocation/active/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cellphone: cellphone }),
    });

    if (response.status === 200 && response != null) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

export async function getAccount(cellphone) {
  try {
    let response = await fetch(`${baseURL}hotspot-account/info/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cellphone: cellphone }),
    });

    if (response.status === 200 && response != null) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("Error:", error);
  }
}

export async function getCellphoneByMAC(macAddress) {
  try {
    let response = await fetch(`${baseURL}get-cellphone/${macAddress}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200 && response != null) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("Error:", error);
  }
}
